"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useRef, useState } from "react";
interface CalendlyApi {
  initInlineWidget: (options: {
    url: string;
    parentElement: HTMLElement;
    prefill?: {
      name?: string;
      email?: string;
    };
  }) => void;
}
declare global {
  interface Window {
    Calendly?: CalendlyApi;
  }
}
export function CalendlyInline(t0) {
  const $ = _c(11);
  const {
    url,
    name,
    email
  } = t0;
  const containerRef = useRef(null);
  const initializedRef = useRef(false);
  const [scriptLoaded, setScriptLoaded] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== email || $[1] !== name || $[2] !== scriptLoaded || $[3] !== url) {
    t1 = () => {
      const container = containerRef.current;
      if (!scriptLoaded || !container || !window.Calendly || initializedRef.current) {
        return;
      }
      initializedRef.current = true;
      const widgetUrl = new URL(url);
      widgetUrl.searchParams.set("hide_gdpr_banner", "1");
      widgetUrl.searchParams.set("primary_color", "2563eb");
      if (document.documentElement.classList.contains("dark")) {
        widgetUrl.searchParams.set("background_color", "0a0a0a");
        widgetUrl.searchParams.set("text_color", "e4e4e7");
      }
      window.Calendly.initInlineWidget({
        url: widgetUrl.toString(),
        parentElement: container,
        prefill: {
          name,
          email
        }
      });
    };
    t2 = [scriptLoaded, url, name, email];
    $[0] = email;
    $[1] = name;
    $[2] = scriptLoaded;
    $[3] = url;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <link rel="stylesheet" href="https://assets.calendly.com/assets/external/widget.css" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Script src="https://assets.calendly.com/assets/external/widget.js" strategy="afterInteractive" onLoad={() => setScriptLoaded(true)} />;
    t5 = <div ref={containerRef} className="h-[1040px] w-full overflow-hidden rounded-xl border border-border bg-card sm:h-[720px]" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== url) {
    t6 = <>{t3}{t4}{t5}<p className="mt-3 text-center text-sm text-muted-foreground">Prefer a new tab?{" "}<a href={url} target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 underline-offset-4 hover:underline dark:text-blue-400">Open the scheduler</a></p></>;
    $[9] = url;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp() {
  return typeof window !== "undefined" && Boolean(window.Calendly);
}